import Image from "@/shared/components/Image/new";
import styles from "./styles.module.css";
import { formatAuthorNames } from "@/shared/functions/formatAthorNames";
import { EnVivo } from "@/shared/components/enVivo";

const NotasAlertaMeteorologica = (props) => {
    const CLIPPING = "3_2_300x200";
    const { content } = props;

    return (

        <div className={styles.parent}>
            {content &&
                content.map((element, index) => {

                    const {
                        subtitle,
                        url,
                        id,
                        title,
                        authors,
                        metadata
                    } = element;


                    // ==========================
                    // ALERTA COLOR + ICONO
                    // ==========================

                    const titulo = `${subtitle || ""} ${title || ""}`.toLowerCase();

                    let alertaClass = styles["alerta-celeste"];
                    let alertaIcono = null;


                    if (titulo.includes("roja")) {

                        alertaClass = styles["alerta-roja"];

                        alertaIcono = (
                            <span className={styles["alerta-icono"]}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="#d90000">
                                    <path d="M8 2h8l6 6v8l-6 6H8l-6-6V8z" />
                                    <rect x="11" y="6" width="2" height="8" fill="#fff" />
                                    <circle cx="12" cy="17" r="1.4" fill="#fff" />
                                </svg>
                            </span>
                        );

                    } else if (titulo.includes("naranja")) {

                        alertaClass = styles["alerta-naranja"];

                        alertaIcono = (
                            <span className={styles["alerta-icono"]}>
                                <svg width="24" height="24" viewBox="0 0 24 24">
                                    <path fill="#ff7a00" d="M12 2L1 21h22L12 2z" />
                                    <rect x="10.5" y="8" width="1.8" height="5.2" fill="#fff" />
                                    <rect x="12.2" y="8" width="1.8" height="5.2" fill="#fff" />
                                    <circle cx="11.4" cy="16.5" r="1" fill="#fff" />
                                    <circle cx="13.1" cy="16.5" r="1" fill="#fff" />
                                </svg>
                            </span>
                        );

                    } else if (titulo.includes("amarilla")) {

                        alertaClass = styles["alerta-amarilla"];

                        alertaIcono = (
                            <span className={styles["alerta-icono"]}>
                                <svg width="24" height="24" viewBox="0 0 24 24">
                                    <path fill="#f7c600" d="M12 2L1 21h22L12 2z" />
                                    <rect x="11" y="8" width="2" height="7" fill="#fff" />
                                    <circle cx="12" cy="18" r="1.3" fill="#fff" />
                                </svg>
                            </span>
                        );

                    } else {

                        alertaIcono = (
                            <span className={styles["alerta-icono"]}>

                            </span>
                        );
                    }


                    let authorsList = [];

                    const parsedAuthors = authorsList.join(" - ");

                    const extraClass =
                        content.length === 4 &&
                            [1, 2, 3].includes(index)
                            ? styles["grid-listado-mobile"]
                            : "";


                    return (

                        <div
                            key={"NotasDePortada" + id + index}
                            className={`${styles["grid-item"]} ${extraClass}`}
                        >

                            <div className={styles["nota-link"]}>

                                <a
                                    href={url}
                                    className={styles["card-link"]}
                                    aria-label={title}
                                >

                                    {metadata?.sponsored ? (

                                        <div className={styles.sponsored}>

                                            <Image
                                                element={element}
                                                clipping={CLIPPING}
                                                width={300}
                                                height={200}
                                                className={styles.img}
                                            />

                                            <span className={styles.badge}>
                                                patrocinado
                                            </span>

                                        </div>

                                    ) : (

                                        <div className={styles["img-container"]}>

                                            <Image
                                                element={element}
                                                clipping={CLIPPING}
                                                width={300}
                                                height={200}
                                                className={styles.img}
                                            />

                                            {metadata?.typeWeb === "live_blog" &&
                                                <EnVivo />
                                            }

                                        </div>

                                    )}

                                    <div className={`${styles["i-c"]} ${alertaClass}`}>

                                        <h2 className={`${styles["titulo-alerta"]} ${alertaClass === styles["alerta-celeste"] ? styles["sin-icono"] : ""}`}>

                                            {alertaIcono}

                                            <span className={styles["titulo-texto"]}>

                                                {subtitle &&
                                                    <span className={styles["blue-txt"]}>
                                                        {subtitle}
                                                    </span>
                                                }

                                                {title}

                                            </span>

                                        </h2>

                                        {parsedAuthors && (

                                            <div
                                                className={styles["note-author"]}
                                                dangerouslySetInnerHTML={{
                                                    __html: "Por " + parsedAuthors
                                                }}
                                            />

                                        )}

                                    </div>

                                </a>

                            </div>

                        </div>

                    );

                })}
        </div>
    );
};


export default NotasAlertaMeteorologica;